import React, { useEffect, useRef, useState } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import TextField from "component/textField/TextField";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import SignatureField from "component/signatureField/SignatureField";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import sig_icon from "assets/images/signature.svg";
import write_icon from "assets/images/write.svg";
import AppDatePicker from "component/inputs/datePicker/DatePicker";

function ESignature({
  watch,
  application,
  formData,
  setValue,
  errors,
  register,
  trigger,
}) {
  const [openSignaturePad, setOpenSignaturePad] = useState(false);
  const sigCanvas = useRef();
  const [base64imageURL, setBase64ImageURL] = useState(null);
  const signatureName = watch("signatureName", "");
  const signDate = watch('signDate', '')
  
    useEffect(() => {
    setBase64ImageURL(application.signature);
  }, [application]);


 

  useEffect(() => {
  
    setValue("signature", base64imageURL);
  }, [base64imageURL]);

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">E-Signature</Typography>
            <Typography>
              Please Sign and Append date so as to complete your Mortgage
              Application
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <AppDatePicker
                    required={true}
                    errors={errors}
                    name="signDate"
                    label="Date"
                    setValue={setValue}
                    value={signDate}
                    trigger={trigger}
                  />
               
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <div className={styles.signature}>
                    <Typography>Signature / Full Name <span style={{color: 'red'}} >*</span> </Typography>
                    <div
                      onClick={() => {
                        setOpenSignaturePad(true);
                      }}
                      className={styles.sign_pad}
                    >
                      {signatureName ? (
                        <div>
                          <Typography>{formData.signatureName}</Typography>

                          <div className={styles.sig_img}>
                            <img src={base64imageURL} alt="signature" />
                          </div>
                        </div>
                      ) : (
                        <>
                          <div>
                            <Typography>Sign Here </Typography>
                            <div>
                              <img src={sig_icon} alt="" />
                            </div>
                          </div>
                          <div>
                            <img src={write_icon} alt="" />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {errors.signatureName && (
                    <ValidationMessage message={errors?.signatureName?.message} />
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {
        <AppBackdrop
          openModal={openSignaturePad}
          children={
            <SignatureField
          
          
              name="signatureName"
              errors={errors}
              setValue={setValue}
              handleCloseField={() => {
            
                trigger('signatureName')
                setOpenSignaturePad(false);
              }}
              setImageURL={setBase64ImageURL}
              sigCanvas={sigCanvas}
            />
          }
        />
      }
    </div>
  );
}

export default ESignature;